import { TransactionDeletionServiceMock } from "./transactionDeletion.types";

export const mockTransactionDeletionService = (): TransactionDeletionServiceMock => ({
  fetchTransactionDeletions: jest.fn(),
  downloadDetailsById: jest.fn(),
  downloadTemplate: jest.fn(),
  isUserAllowed: jest.fn(),
  uploadDeletionFile: jest.fn(),
});


